// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayloadStagingV1DataGetDataSystemCodeSystemIdPurposeCodePurposeIdGetDataResponse {
    static getAttributeTypeMap() {
        return PayloadStagingV1DataGetDataSystemCodeSystemIdPurposeCodePurposeIdGetDataResponse.attributeTypeMap;
    }
}
PayloadStagingV1DataGetDataSystemCodeSystemIdPurposeCodePurposeIdGetDataResponse.discriminator = undefined;
PayloadStagingV1DataGetDataSystemCodeSystemIdPurposeCodePurposeIdGetDataResponse.additionalProperties = false;
PayloadStagingV1DataGetDataSystemCodeSystemIdPurposeCodePurposeIdGetDataResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payloadStagingV1DataGetDataSystemCodeSystemIdPurposeCodePurposeIdGetDataResponse.js.map